import { MuiButton } from '@/components/button/MuiButton';
import { ArrowUpIcon } from '@/features/icon/ArrowUpIcon';
import { Box, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

type Props = {
  text: string;
};

export function DocumentTextBox({ text }: Props) {
  const textRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      const isOver = el.scrollHeight > el.clientHeight;
      setIsOverflowing(isOver);
    }
  }, [text]);

  return (
    <Box>
      <Typography
        ref={textRef}
        sx={{
          whiteSpace: 'pre-wrap',
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: expanded ? 'none' : 4,
        }}
      >
        {text}
      </Typography>

      {isOverflowing && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
          <MuiButton
            variant="text"
            onClick={() => setExpanded((prev) => !prev)}
            sx={{ mt: 1, px: 3 }}
            endIcon={
              <ArrowUpIcon
                width={10}
                height={10}
                sxProps={{ transform: expanded ? '' : 'rotate(180deg)' }}
              />
            }
          >
            {expanded ? '一部を表示' : 'もっと見る'}
          </MuiButton>
        </Box>
      )}
    </Box>
  );
}
